import { useCallback } from 'react';

import useLazyQueryWithPromise from '@hooks/useLazyQueryWithPromise';
import {
  GetGoalTemplatesSearchDocument,
  GetGoalTemplatesSearchQuery,
  GetGoalTemplatesSearchQueryVariables
} from '@typing/Generated';

const useSearchGoalTemplates = (onClick: (id: string, title: string) => void) => {
  const getGoalTemplatesSearch = useLazyQueryWithPromise<
    GetGoalTemplatesSearchQuery,
    GetGoalTemplatesSearchQueryVariables
  >(GetGoalTemplatesSearchDocument);

  const searchOptions = useCallback(
    (v: string) =>
      getGoalTemplatesSearch({
        variables: {
          count: 35,
          search: v
        }
      }).then(res => {
        const nodes = (res.data?.goalTemplatesSearch ?? []).map(node => ({
          category: '',
          highlight: node.highlight,
          label: node.title,
          onClick: () => onClick(node.id, node.title),
          value: node.id
        }));

        return [
          {
            label: '',
            options: nodes
          }
        ];
      }),
    [getGoalTemplatesSearch, onClick]
  );

  return searchOptions;
};

export default useSearchGoalTemplates;
